// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/query-person-matches.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_AppointmentOverlay_Content(
  $first_name: String!
  $last_name: String!
  $birth_date: date!
  $birth_date_s: String!
) {
  vaxiom_persons_aggregate(
    where: {
      first_name: { _ilike: $first_name }
      last_name: { _ilike: $last_name }
      birth_date: { _eq: $birth_date }
    }
  ) {
    aggregate {
      count
    }
  }
  leads_leads_aggregate(
    where: {
      first_name: { _ilike: $first_name }
      last_name: { _ilike: $last_name }
      birth_date: { _eq: $birth_date_s }
      patient_id: { _is_null: true }
    }
  ) {
    aggregate {
      count
    }
  }
}

`